import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=21f65ea0&"
import script from "./Display.vue?vue&type=script&lang=ts&"
export * from "./Display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports